export function scrollToElement(element: HTMLElement | null) {
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export function scrollToTop() {
  window.scrollTo(0, 0);
}
